import React, { useContext, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { withRouter } from 'react-router-dom';
import { screenReaderAnnounce } from 'premier-capability-hooks';
import metadata from './QuoteDetailsComponent.metadata.json5';
import styles from './QuoteDetailsComponent.module.scss';
import { CurrencyInput, TextInput } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function QuoteDetailsComponent(props) {
    const {
        wizardData: submissionVM
    } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('QuoteDetailsComponent');
    const periodStartDate = _.get(submissionVM.value, 'baseData.periodStartDate');
    const periodEndDate = _.get(submissionVM.value, 'baseData.periodEndDate');

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        subConQuo4: {
            visible: _.get(submissionVM.value, 'lobData.cybLiaLine.selectedOffering_Ext') === 'DirAndOff'
        },
        addReq2: {
            visible: _.get(submissionVM.value, 'lobData.proLcybLiaLineine.selectedOffering_Ext') === 'DirAndOff'
        },
        taxes: {
            visible: _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC' && !_.isUndefined(submissionVM.value.baseData.isApplicableForQCTax) && submissionVM.value.baseData.isApplicableForQCTax,
            value: _.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.taxes') !== undefined ?
            {
                ... (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.taxes')),
                currency: (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.taxes')?.currency?.toUpperCase())
            } : undefined
        },
        policyFee: {
            visible: _.get(submissionVM.value, 'baseData.policyFee_Ext.amount') !== 0,
            value: _.get(submissionVM.value, 'baseData.policyFee_Ext') !== undefined ?
            {
                ... (_.get(submissionVM.value, 'baseData.policyFee_Ext')),
                currency: (_.get(submissionVM.value, 'baseData.policyFee_Ext')?.currency?.toUpperCase())
            } : undefined
        },
        inspectionFee: {
            visible: _.get(submissionVM.value, 'baseData.inspectionFee_Ext.amount') !== 0,
            value: _.get(submissionVM.value, 'baseData.inspectionFee_Ext') !== undefined ?
            {
                ... (_.get(submissionVM.value, 'baseData.inspectionFee_Ext')),
                currency: (_.get(submissionVM.value, 'baseData.inspectionFee_Ext')?.currency?.toUpperCase())
            } : undefined
        },
        extensionFee: {
            visible: _.get(submissionVM.value, 'baseData.extensionFee_Ext.amount') !== 0,
            value: _.get(submissionVM.value, 'baseData.extensionFee_Ext') !== undefined ?
            {
                ... (_.get(submissionVM.value, 'baseData.extensionFee_Ext')),
                currency: (_.get(submissionVM.value, 'baseData.extensionFee_Ext')?.currency?.toUpperCase())
            } : undefined
        },
        policyStartDate: {
            value: new Date(periodStartDate.year, periodStartDate.month, periodStartDate.day).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' })
        },
        policyEndDate: {
            value: new Date(periodEndDate.year, periodEndDate.month, periodEndDate.day).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' })
        },
        policyStatus: {
            value: _.get(submissionVM.value, 'baseData.periodStatus')
        },
        totalPremium: {
            value: _.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.totalBeforeTaxes') !== undefined ?
            {
                ... (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.totalBeforeTaxes')),
                currency: (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.totalBeforeTaxes')?.currency?.toUpperCase())
            } : undefined
        },
        totalCost: {
            value: _.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.total') !== undefined ?
            {
                ... (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.total')),
                currency: (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.total')?.currency?.toUpperCase())
            } : undefined
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
        },
        resolveComponentMap: {
            TextInput,
            CurrencyInput
        },
        resolveClassNameMap: styles        
    };


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

QuoteDetailsComponent.propTypes = wizardProps;
export default withRouter(QuoteDetailsComponent);